import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=35cbcf24&scoped=true&v-if=user&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cbcf24",
  null
  
)

export default component.exports